module.exports = __webpack_public_path__ + "static/media/amacorp.eb4ecdb6.png";